/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-state
 * OpenAPI spec version: 1.0.0
 */
import type {
  AbacusStateResponse,
  AbacusStatesResponse,
  CreateAbacusStatesBody,
  CreateAbacusStatesByParentTableHeaders,
  CreateAbacusStatesByParentTableParams,
  CreateAbacusStatesByParentTablePathParameters,
  CreateAbacusStatesHeaders,
  DataloadAbacusStatesHeaders,
  DataloadAbacusStatesResponse,
  GetAbacusStateHeaders,
  GetAbacusStatePathParameters,
  GetAbacusStatesBody,
  GetAbacusStatesByParentTableHeaders,
  GetAbacusStatesByParentTablePathParameters,
  GetHealthHeaders,
  HealthResponse,
  UpdateAbacusStateBody,
  UpdateAbacusStateHeaders,
  UpdateAbacusStatePathParameters,
  UpdateAbacusStatesBody,
  UpdateAbacusStatesHeaders,
  UpdateAbacusStatesPathParameters,
} from "./types";
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];
/**
 * Generated by @abacus/api-client-generator
 * Do not edit manually.
 */
import Axios, { type AxiosInstance, type AxiosRequestConfig } from "axios";

import { type Logger, type HeaderProvider } from "@abacus/common";

import { type Throttler } from "@abacus/throttlers";

import { ApiResponse } from "./common";

export interface ApiConfig {
  auth?: HeaderProvider;
  axios?: AxiosInstance;
  baseUrl?: string;
  logger?: Logger;
  throttler?: Throttler;
}

export class OwsAbacusStateClient {
  auth?: HeaderProvider;
  axios: AxiosInstance;
  baseUrl: string;
  logger?: Logger;
  throttler?: Throttler;

  constructor(config?: ApiConfig) {
    this.auth = config?.auth;
    this.axios = config?.axios ?? Axios.create();
    this.baseUrl = config?.baseUrl ?? `https://localhost:8080`;
    this.logger = config?.logger;
    this.throttler = config?.throttler;
  }

  async _fetch<T>(
    config: AxiosRequestConfig,
    options?: AxiosRequestConfig,
  ): Promise<ApiResponse<T>> {
    // On request
    config = await this._onRequest(config, options);
    // Make request
    const response = await this.axios(config);
    // Get data
    const data = response.data;
    const headers = response.headers as Record<string, string>;
    // Return response
    return { data, headers, status: response.status };
  }

  private async _getHeaders(
    headers?: Record<string, string>,
  ): Promise<Record<string, string>> {
    return {
      ...(await this.auth?.getHeaders()),
      ...headers,
    };
  }

  private async _onRequest(
    config: AxiosRequestConfig,
    options?: AxiosRequestConfig,
  ): Promise<AxiosRequestConfig> {
    // Throttle the request
    await this.throttler?.wait();
    // Update config
    config = { ...config, ...options };
    // Add base URL
    config.baseURL ??= this.baseUrl;
    // Add headers
    const headers = config.headers as Record<string, string>;
    config.headers = await this._getHeaders(headers);
    // Log the request
    this.logger?.debug(`Requesting ${config.method} ${config.url}`);
    return config;
  }

  getAbacusState(
    { abacusStateId }: GetAbacusStatePathParameters,
    headers?: GetAbacusStateHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<AbacusStateResponse>(
        { url: `/abacus-state/${abacusStateId}/`, method: "GET", headers },
        options,
      );
    }
  }

  updateAbacusState(
    { abacusStateId }: UpdateAbacusStatePathParameters,
    updateAbacusStateBody: UpdateAbacusStateBody,
    headers?: UpdateAbacusStateHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<AbacusStateResponse>(
        {
          url: `/abacus-state/${abacusStateId}/`,
          method: "PUT",
          headers: { "Content-Type": "application/json", ...headers },
          data: updateAbacusStateBody,
        },
        options,
      );
    }
  }

  getAbacusStatesByParentTable(
    {
      parentTableName,
      parentTableId,
    }: GetAbacusStatesByParentTablePathParameters,
    headers?: GetAbacusStatesByParentTableHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<AbacusStatesResponse>(
        {
          url: `/abacus-state/${parentTableName}/${parentTableId}/`,
          method: "GET",
          headers,
        },
        options,
      );
    }
  }

  dataloadAbacusStates(
    getAbacusStatesBody: GetAbacusStatesBody,
    headers?: DataloadAbacusStatesHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<DataloadAbacusStatesResponse>(
        {
          url: `/abacus-state/dataloader`,
          method: "POST",
          headers: { "Content-Type": "application/json", ...headers },
          data: getAbacusStatesBody,
        },
        options,
      );
    }
  }

  createAbacusStates(
    createAbacusStatesBody: CreateAbacusStatesBody,
    headers?: CreateAbacusStatesHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<AbacusStatesResponse>(
        {
          url: `/abacus-states/`,
          method: "POST",
          headers: { "Content-Type": "application/json", ...headers },
          data: createAbacusStatesBody,
        },
        options,
      );
    }
  }

  updateAbacusStates(
    { parentTableName }: UpdateAbacusStatesPathParameters,
    updateAbacusStatesBody: UpdateAbacusStatesBody,
    headers?: UpdateAbacusStatesHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<AbacusStatesResponse>(
        {
          url: `/abacus-states/${parentTableName}/`,
          method: "PUT",
          headers: { "Content-Type": "application/json", ...headers },
          data: updateAbacusStatesBody,
        },
        options,
      );
    }
  }

  createAbacusStatesByParentTable(
    {
      parentTableName,
      parentTableId,
    }: CreateAbacusStatesByParentTablePathParameters,
    params?: CreateAbacusStatesByParentTableParams,
    headers?: CreateAbacusStatesByParentTableHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<AbacusStatesResponse>(
        {
          url: `/abacus-states/${parentTableName}/${parentTableId}/`,
          method: "POST",
          headers,
          params,
        },
        options,
      );
    }
  }

  getHealth(
    headers?: GetHealthHeaders,
    options?: SecondParameter<typeof this._fetch>,
  ) {
    {
      return this._fetch<HealthResponse>(
        { url: `/hello/`, method: "GET", headers },
        options,
      );
    }
  }
}
